/**
 * Created by vladislav on 1/18/2024
 */

const CoolMathGamesLogic = function () {
    PlatformLogic.call(this);
};

CoolMathGamesLogic.prototype = Object.create(PlatformLogic.prototype);
CoolMathGamesLogic.prototype.constructor = CoolMathGamesLogic;